import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { validateAttributes, errorMessage } from "../../utils/validations";
import { validations } from "./validations";
import { ToastContainer, toast } from "react-toastify";

const Passwords = (props) => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [errors, setErrors] = useState({});

  const updatePassword = async () => {
    const response = await fetch("/settings/update_password", {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
      },
      body: JSON.stringify({
        user: {
          current_password: oldPassword,
          password: newPassword,
          password_confirmation: confirmNewPassword,
        },
      }),
    });
    if (response.ok) {
      setErrors({});
      setOldPassword("");
      setNewPassword("");
      setConfirmNewPassword("");

      toast.success("Hasło zostało zmienione pomyślnie!");
    } else {
      const data = await response.json();

      if (data.errors == "invalid_current_password") {
        setErrors({ oldPassword: ["invalidCurrentPassword"] });
        setOldPassword("");
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let validation = validateAttributes(
      { oldPassword, newPassword, confirmNewPassword },
      validations,
    );

    if (validPasswordMatch()) {
      if (!validation) validation = {};
      validation.confirmNewPassword = ["matchNewPassword"];
    }

    if (!validPasswordLength()) {
      if (!validation) validation = {};
      validation.newPasswordLength = ["minLength"];
    }

    if (!validPasswordNumeric()) {
      if (!validation) validation = {};
      validation.newPasswordNumeric = ["numericChar"];
    }

    if (!validPasswordSpecialChar()) {
      if (!validation) validation = {};
      validation.newPasswordSpecialChar = ["specialChar"];
    }

    if (!validPasswordCase()) {
      if (!validation) validation = {};
      validation.newPasswordCase = ["caseChar"];
    }

    if (validation) {
      setErrors(validation);
      return;
    }

    updatePassword();
  };

  const textColor = (isValid, isError) => {
    if (isError) return "text-red-500";

    return isValid ? "text-primaryYellow" : "text-gray-500";
  };

  const validPasswordLength = () => {
    return newPassword.length >= 8;
  };
  const validPasswordNumeric = () => {
    return /\d/.test(newPassword);
  };
  const validPasswordSpecialChar = () => {
    return /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(newPassword);
  };
  const validPasswordCase = () => {
    return (
      newPassword != "" &&
      /[a-z]/.test(newPassword) &&
      /[A-Z]/.test(newPassword)
    );
  };
  const validPasswordMatch = () => {
    return confirmNewPassword !== "" && newPassword !== confirmNewPassword;
  };

  useEffect(() => {
    let newErrors = errors;
    if (errors) {
      if (validPasswordLength()) {
        const { newPasswordLength, ...rest } = newErrors;
        newErrors = rest;
      }
      if (validPasswordNumeric()) {
        const { newPasswordNumeric, ...rest } = newErrors;
        newErrors = rest;
      }
      if (validPasswordSpecialChar()) {
        const { newPasswordSpecialChar, ...rest } = newErrors;
        newErrors = rest;
      }
      if (validPasswordCase()) {
        const { newPasswordCase, ...rest } = newErrors;
        newErrors = rest;
      }

      const { newPassword, ...rest } = newErrors;
      newErrors = rest;

      setErrors(newErrors);
    }
  }, [newPassword]);

  useEffect(() => {
    let newErrors = errors;

    if (errors) {
      if (validPasswordMatch()) {
        const { newPasswordConfirmation, ...rest } = newErrors;
        newErrors = rest;
      }

      const { confirmNewPassword, ...rest } = newErrors;
      newErrors = rest;

      setErrors(newErrors);
    }
  }, [confirmNewPassword]);

  const toggleOldPasswordVisibility = () => {
    setShowOldPassword(!showOldPassword);
  };

  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const EyeIcon = ({ isVisible, onClick }) => (
    <button
      type="button"
      onClick={onClick}
      className="absolute right-3 top-2.5 text-gray-400 hover:text-gray-600"
    >
      {isVisible ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 1-4.243-4.243m4.242 4.242L9.88 9.88"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
          />
        </svg>
      )}
    </button>
  );

  return (
    <>
      <ToastContainer position="top-center" />
      <h1 className="text-2xl font-bold mb-2">Zmiana hasła</h1>

      <div className="flex items-center gap-4 text-sm mb-6">
        <div
          className={`flex items-center gap-1 ${textColor(validPasswordLength(), errors["newPasswordLength"])}`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="size-4"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>
          Min. 8 znaków
        </div>
        <div
          className={`flex items-center gap-1 ${textColor(validPasswordNumeric(), errors["newPasswordNumeric"])}`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="size-4"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>
          Cyfry
        </div>
        <div
          className={`flex items-center gap-1 ${textColor(validPasswordSpecialChar(), errors["newPasswordSpecialChar"])}`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="size-4"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>
          Znaki specjalne
        </div>
        <div
          className={`flex items-center gap-1 ${textColor(validPasswordCase(), errors["newPasswordCase"])}`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="size-4"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>
          Małe i duże litery
        </div>
      </div>

      <form className="max-w-md">
        <div className="mb-4">
          <label className="block text-sm font-medium text-black mb-1">
            Stare hasło
          </label>
          <div className="relative">
            <input
              type={showOldPassword ? "text" : "password"}
              className="w-full border border-gray-300 px-3 py-2 pr-10"
              onChange={(e) => setOldPassword(e.target.value)}
              value={oldPassword}
            />
            <EyeIcon
              isVisible={showOldPassword}
              onClick={toggleOldPasswordVisibility}
            />
          </div>

          {errorMessage(errors, "oldPassword")}
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-black mb-1">
            Nowe hasło
          </label>
          <div className="relative">
            <input
              type={showNewPassword ? "text" : "password"}
              className="w-full border border-gray-300 px-3 py-2 pr-10"
              onChange={(e) => setNewPassword(e.target.value)}
              value={newPassword}
            />
            <EyeIcon
              isVisible={showNewPassword}
              onClick={toggleNewPasswordVisibility}
            />
          </div>

          {errorMessage(errors, "newPassword")}
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-black mb-1">
            Powtórz nowe hasło
          </label>
          <div className="relative">
            <input
              type={showConfirmPassword ? "text" : "password"}
              className="w-full border border-gray-300 px-3 py-2 pr-10"
              onChange={(e) => setConfirmNewPassword(e.target.value)}
              value={confirmNewPassword}
            />
            <EyeIcon
              isVisible={showConfirmPassword}
              onClick={toggleConfirmPasswordVisibility}
            />
          </div>

          {errorMessage(errors, "confirmNewPassword")}
        </div>

        <button
          type="submit"
          className="bg-black text-white px-4 py-2 text-sm font-medium"
          onClick={handleSubmit}
        >
          Ustaw nowe hasło
        </button>
      </form>
    </>
  );
};

Passwords.propTypes = {};

export default Passwords;
